// extracted by mini-css-extract-plugin
module.exports = {"shopName":"store_shopName__FyHc5","shopIcon":"store_shopIcon__Apmsz","icon":"store_icon__sPF2_","shopIconGrid":"store_shopIconGrid__KV5ar"};